interface IDocumentsDetailsProps {
  documents: {
    proofOfOwnership: any[];
    proofOfOccupancy: any[];
    zeroIncomeAffidavit: any[];
    bankStatements: any[];
    proofOfIncome: any[];
  };
  files: any[]; // <-- Add this prop
}

export default function DocumentsDetails({ documents, files = [] }: IDocumentsDetailsProps) {
  const getFileWithUrl = (fileMeta: any) => files.find((f) => f.key === fileMeta.key);

  return (
    <section aria-labelledby='documents-title'>
      <div className='bg-white shadow sm:rounded-lg'>
        <div className='py-5'>
          <div className='px-4 py-2 sm:px-6 border-l-4 border-primaryColor-normal'>
            <h2 id='documents-title' className='m-0 text-lg leading-6 font-medium text-primaryColor-normal'>
              Documents
            </h2>
          </div>
        </div>
        <div className='border-t border-gray-200 px-4 py-5 sm:px-6 flex flex-col gap-3'>
          <div className='space-y-4'>
            <div>
              <h3 className='text-sm font-medium text-gray-500 mb-2'>Proof of Ownership - Title Deed</h3>
              <div className='text-sm text-gray-900'>
                {documents?.proofOfOwnership?.length > 0 ? (
                  <ul className='list-disc list-inside'>
                    {documents.proofOfOwnership.map((file: any, index: number) => {
                      const downloadable = getFileWithUrl(file);
                      return (
                        <li key={`ownership-${file.name || index}-${index}`}>
                          {downloadable?.url ? (
                            <a
                              href={downloadable.url}
                              target='_blank'
                              rel='noopener noreferrer'
                              className='text-blue-600 underline'
                              download
                            >
                              {file.name || `File ${index + 1}`}
                            </a>
                          ) : (
                            <>
                              {file.name || `File ${index + 1}`}
                              <span className='text-red-500 ml-2'>(No download URL found)</span>
                            </>
                          )}
                        </li>
                      );
                    })}
                  </ul>
                ) : (
                  <span className='text-gray-400'>No files uploaded</span>
                )}
              </div>
            </div>
            <div>
              <h3 className='text-sm font-medium text-gray-500 mb-2'>Proof of Occupancy - Utility Bill</h3>
              <div className='text-sm text-gray-900'>
                {documents?.proofOfOccupancy?.length > 0 ? (
                  <ul className='list-disc list-inside'>
                    {documents.proofOfOccupancy.map((file: any, index: number) => {
                      const downloadable = getFileWithUrl(file);
                      return (
                        <li key={`occupancy-${file.name || index}-${index}`}>
                          {downloadable?.url ? (
                            <a
                              href={downloadable.url}
                              target='_blank'
                              rel='noopener noreferrer'
                              className='text-blue-600 underline'
                              download
                            >
                              {file.name || `File ${index + 1}`}
                            </a>
                          ) : (
                            <>
                              {file.name || `File ${index + 1}`}
                              <span className='text-red-500 ml-2'>(No download URL found)</span>
                            </>
                          )}
                        </li>
                      );
                    })}
                  </ul>
                ) : (
                  <span className='text-gray-400'>No files uploaded</span>
                )}
              </div>
            </div>
            <div>
              <h3 className='text-sm font-medium text-gray-500 mb-2'>Zero Income Affidavit</h3>
              <div className='text-sm text-gray-900'>
                {documents?.zeroIncomeAffidavit?.length > 0 ? (
                  <ul className='list-disc list-inside'>
                    {documents.zeroIncomeAffidavit.map((file: any, index: number) => {
                      const downloadable = getFileWithUrl(file);
                      return (
                        <li key={`zeroIncome-${file.name || index}-${index}`}>
                          {downloadable?.url ? (
                            <a
                              href={downloadable.url}
                              target='_blank'
                              rel='noopener noreferrer'
                              className='text-blue-600 underline'
                              download
                            >
                              {file.name || `File ${index + 1}`}
                            </a>
                          ) : (
                            <>
                              {file.name || `File ${index + 1}`}
                              <span className='text-red-500 ml-2'>(No download URL found)</span>
                            </>
                          )}
                        </li>
                      );
                    })}
                  </ul>
                ) : (
                  <span className='text-gray-400'>No files uploaded</span>
                )}
              </div>
            </div>
            <div>
              <h3 className='text-sm font-medium text-gray-500 mb-2'>Bank Statements</h3>
              <div className='text-sm text-gray-900'>
                {documents?.bankStatements?.length > 0 ? (
                  <ul className='list-disc list-inside'>
                    {documents.bankStatements.map((file: any, index: number) => {
                      const downloadable = getFileWithUrl(file);
                      return (
                        <li key={`bankStatements-${file.name || index}-${index}`}>
                          {downloadable?.url ? (
                            <a
                              href={downloadable.url}
                              target='_blank'
                              rel='noopener noreferrer'
                              className='text-blue-600 underline'
                              download
                            >
                              {file.name || `File ${index + 1}`}
                            </a>
                          ) : (
                            <>
                              {file.name || `File ${index + 1}`}
                              <span className='text-red-500 ml-2'>(No download URL found)</span>
                            </>
                          )}
                        </li>
                      );
                    })}
                  </ul>
                ) : (
                  <span className='text-gray-400'>No files uploaded</span>
                )}
              </div>
            </div>
            <div>
              <h3 className='text-sm font-medium text-gray-500 mb-2'>Proof of Income</h3>
              <div className='text-sm text-gray-900'>
                {documents?.proofOfIncome?.length > 0 ? (
                  <ul className='list-disc list-inside'>
                    {documents.proofOfIncome.map((file: any, index: number) => {
                      const downloadable = getFileWithUrl(file);
                      return (
                        <li key={`proofOfIncome-${file.name || index}-${index}`}>
                          {downloadable?.url ? (
                            <a
                              href={downloadable.url}
                              target='_blank'
                              rel='noopener noreferrer'
                              className='text-blue-600 underline'
                              download
                            >
                              {file.name || `File ${index + 1}`}
                            </a>
                          ) : (
                            <>
                              {file.name || `File ${index + 1}`}
                              <span className='text-red-500 ml-2'>(No download URL found)</span>
                            </>
                          )}
                        </li>
                      );
                    })}
                  </ul>
                ) : (
                  <span className='text-gray-400'>No files uploaded</span>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
